import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";




const initialState = {
    orders: [],
    isLoading: true,
    isViewModalOpen: false,
    isDeleteModalOpen: false,
    viewSingleOrder:{}
}

export const getOrders = createAsyncThunk(
    'users/getOrders',
    async (_, thunkAPI) => {
      const response = await axios.get("https://629b40cdcf163ceb8d16b9d9.mockapi.io/orders")
      return response.data
    }
  )



const orderSlice = createSlice({
    name: "orders",
    initialState,
    reducers:{
     viewOrder: (state, action)=>{
        state.isViewModalOpen = true
        state.viewSingleOrder= action.payload
     
     },
     openDeleteModal: (state, action)=>{
        state.isDeleteModalOpen = true
        state.viewSingleOrder= action.payload
     },
     closeModal: (state)=>{
        state.isViewModalOpen = false
        state.isDeleteModalOpen = false
        state.viewSingleOrder=  {}
     }

    },
    extraReducers: (builder)=>{
        builder.addCase(getOrders.pending, (state)=>{
            state.isLoading = true
        })
        builder.addCase(getOrders.fulfilled, (state, action)=>{
            state.isLoading = false
            state.orders = action.payload
        })
        builder.addCase(getOrders.rejected, (state, action)=>{
            state.isLoading = true
            console.error(action.error);
        })
    }
})

export const { viewOrder, openDeleteModal, closeModal } = orderSlice.actions
export default orderSlice.reducer